<template>
  <div class="energyManageZhuan">
    <el-card class="topCard">
      <span>综合管理</span>
      <div class="btns">
        <el-button @click="handelChangeMok(1)" :class="{ active: num === 1 }">
          基本信息
        </el-button>
        <span>|</span>
        <el-button @click="handelChangeMok(2)" :class="{ active: num === 2 }">
          电价上传
        </el-button>
        <!-- <span>|</span> -->
        <!-- <el-button @click="handelChangeMok(3)" :class="{ active: num === 3 }">
          数据采集
        </el-button> -->
        <span>|</span>
        <el-button @click="handelChangeMok(4)" :class="{ active: num === 4 }">
          合同管理
        </el-button>
        <span>|</span>
        <el-button @click="handelChangeMok(5)" :class="{ active: num === 5 }">
          业务审核
        </el-button>
      </div>
    </el-card>
    <el-card class="bottomCard" v-if="num !== 5">
      <div class="bottomCard1" v-show="num === 1">
        <FirstHeading style="margin-bottom: 20px">基本信息</FirstHeading>
        <div class="infoBox">
          <div>
            转供电主户号：
            <span>{{ userNum }}</span>
          </div>
          <div>
            供电单位：
            <span>自动识别到供电单位</span>
          </div>
        </div>
      </div>
      <div class="bottomCard2" v-show="num === 2">
        <FirstHeading style="margin-bottom: 20px">电价上传</FirstHeading>
        <div class="infoBox">
          <div class="feng">
            <span>峰时电价：</span>
            <el-input
              class="input"
              placeholder="转供电主体1号"
              v-model="feng"
              @change="handelChangePrice(feng)"
              clearable>
              <i slot="suffix" class="yuan">元</i>
            </el-input>
          </div>
          <div class="ping">
            <span>平时电价：</span>
            <el-input
              class="input"
              placeholder="转供电主体1号"
              v-model="ping"
              @change="handelChangePrice(ping)"
              clearable>
              <i slot="suffix" class="yuan">元</i>
            </el-input>
          </div>
          <div class="gu">
            <span>谷时电价：</span>
            <el-input
              class="input"
              placeholder="转供电主体1号"
              v-model="gu"
              @change="handelChangePrice(gu)"
              clearable>
              <i slot="suffix" class="yuan">元</i>
            </el-input>
          </div>
          <div class="line"></div>
          <el-button @click="handleSubmitPrice">确认修改</el-button>
        </div>
      </div>
      <div class="bottomCard3" v-show="num === 3">
        <FirstHeading style="margin-bottom: 20px">数据采集</FirstHeading>
        <el-table
          :data="tableData2"
          border
          style="width: 100%; height: 100%"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '7px 0' }"
          :header-cell-style="{
            background: '#e2eeeb',
            fontSize: '14px',
            color: '#000',
            fontWeight: 400,
            padding: '7px 0',
          }">
          <el-table-column
            prop="userNum"
            label="转供电主体编号"
            align="center"></el-table-column>
          <el-table-column
            prop="userName"
            label="用户名称"
            align="center"></el-table-column>
          <el-table-column
            prop="allEle"
            label="电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="fengEle"
            label="峰用电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="guEle"
            label="谷用电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="pingEle"
            label="平用电量(kWh)"
            align="center"></el-table-column>
          <!-- <el-table-column prop="electric" label="电表读数(kWh)" align="center">
            <template slot-scope="scope">
              <div class="inputP" @click="handelInputElectE(scope.row)">
                <span v-if="!scope.row.electricInputE">
                  {{ scope.row.electricNum }}
                </span>
                <el-input v-else v-model="scope.row.electricNum" />
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="power"
            label="功率(kW)"
            align="center"></el-table-column>
          <!-- <el-table-column prop="power" label="功率(kWh)" align="center">
            <template slot-scope="scope">
              <div class="inputP" @click="handelInputElectEP(scope.row)">
                <span v-if="!scope.row.electricInputEP">
                  {{ scope.row.electricp }}
                </span>
                <el-input v-else v-model="scope.row.electricp" />
              </div>
            </template>
          </el-table-column> -->
        </el-table>

        <el-table
          :data="tableData1"
          border
          style="width: 100%; height: 100%; margin-top: 20px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '7px 0' }"
          :header-cell-style="{
            background: '#e2eeeb',
            fontSize: '14px',
            color: '#000',
            fontWeight: 400,
            padding: '7px 0',
          }">
          <el-table-column
            prop="userNum"
            label="终端用户编号"
            align="center"></el-table-column>
          <el-table-column
            prop="userName"
            label="用户名称"
            align="center"></el-table-column>
          <el-table-column
            prop="userNum"
            label="电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="fengEle"
            label="峰用电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="guEle"
            label="谷用电量(kWh)"
            align="center"></el-table-column>
          <el-table-column
            prop="pingEle"
            label="平用电量(kWh)"
            align="center"></el-table-column>
          <!-- <el-table-column prop="electric" label="电表读数（Kwh）" align="center">
            <template slot-scope="scope">
              <div class="inputP" @click="handelInputElectE(scope.row)">
                <span v-if="!scope.row.electricInputE">
                  {{ scope.row.electricNum }}
                </span>
                <el-input v-else v-model="scope.row.electricNum" />
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="power"
            label="功率(kW)"
            align="center"></el-table-column>
          <!-- <el-table-column prop="electricp" label="功率(kWh)" align="center">
            <template slot-scope="scope">
              <div class="inputP" @click="handelInputElectEP(scope.row)">
                <span v-if="!scope.row.electricInputEP">
                  {{ scope.row.electricp }}
                </span>
                <el-input v-else v-model="scope.row.electricp" />
              </div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="handleSubmit(scope.row)">提交</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottomCard4" v-show="num === 4">
        <el-tabs v-model="activeName" @tab-click="changeTabs">
          <el-tab-pane label="合同上传" name="upload">
            <FirstHeading :find="true" style="margin-bottom: 20px"
              >合同上传</FirstHeading
            >
            <el-table
              :data="tableData3"
              border
              height="700"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '7px 0' }"
              :header-cell-style="{
                background: '#e2eeeb',
                fontSize: '14px',
                color: '#000',
                fontWeight: 400,
                padding: '7px 0',
              }">
              <el-table-column
                prop="userNum"
                label="终端用户编号"
                align="center"></el-table-column>
              <el-table-column
                prop="userName"
                label="用户名称"
                align="center"></el-table-column>
              <el-table-column label="用电合同" align="center">
                <template slot-scope="scope">
                  <el-button
                    class="uploadBtn"
                    type="text"
                    @click="handelUserNum(scope.row.userNum)">
                    上传
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="历史合同" name="history">
            <FirstHeading :find="false" style="margin-bottom: 20px"
              >历史合同</FirstHeading
            >
            <!-- <el-form :inline="true" ref="searchRef" :model="searchForm" class="demo-form-inline">
              <el-form-item label="用户编号">
                <el-input v-model="searchForm.userNum" placeholder="请输入用户编号"></el-input>
              </el-form-item>
              <el-form-item label="合同编号">
                <el-input v-model="searchForm.fileNum" placeholder="请输入合同编号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSearch" class="searchBtn">查询</el-button>
              </el-form-item>
            </el-form> -->
            <el-table
              :data="tableData4"
              border
              height="700"
              :row-style="{ height: '0' }"
              :cell-style="{ padding: '7px 0' }"
              :header-cell-style="{
                background: '#e2eeeb',
                fontSize: '14px',
                color: '#000',
                fontWeight: 400,
                padding: '7px 0',
              }">
              <el-table-column
                prop="userNum"
                label="终端用户编号"
                align="center"></el-table-column>
              <el-table-column
                prop="userName"
                label="用户名称"
                align="center"></el-table-column>
              <el-table-column
                prop="contractType"
                label="合同类型"
                align="center">
                <template slot-scope="scope">
                  {{
                    scope.row.contractType === 0
                      ? "用电合同"
                      : scope.row.contractType === 1
                      ? "扩容合同"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="contractNum"
                label="合同编号"
                align="center"></el-table-column>
              <el-table-column
                prop="signTime"
                label="签订日期"
                align="center"></el-table-column>
              <el-table-column
                prop="takeTime"
                label="生效日期"
                align="center"></el-table-column>
              <el-table-column
                prop="endTime"
                label="终止日期"
                align="center"></el-table-column>
              <el-table-column
                prop="qklHash"
                label="区块链认证"
                align="center"
                width="600px">
                <template slot-scope="scope">
                  <el-tag
                    type="success"
                    style="color: #068d6c; margin-bottom: 5px"
                    >{{ scope.row.qklHash }}</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column label="附件" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="color: #068d6c"
                    @click="changeViewUserNum(scope.row)">
                    查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <div class="bottom" v-else>
      <el-card class="box" v-for="item in dataList" :key="item.workNum">
        <div style="margin-bottom: 10px">工单号：{{ item.workNum }}</div>
        <el-table
          :data="item.list"
          style="width: 100%"
          border
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '7px 0' }"
          :header-cell-style="{
            background: '#e2eeeb',
            fontSize: '14px',
            color: '#000',
            fontWeight: 400,
            padding: '7px 0',
          }">
          <el-table-column prop="userNum" label="用户编号"> </el-table-column>
          <el-table-column prop="userName" label="用户名称"> </el-table-column>
          <el-table-column prop="phone" label="联系方式"> </el-table-column>
          <el-table-column prop="identity" label="身份证号"> </el-table-column>
          <el-table-column prop="address" label="用电地址"> </el-table-column>
          <el-table-column prop="type" label="申报类型"> </el-table-column>
          <el-table-column prop="isBuilding" label="是否施工">
          </el-table-column>
          <el-table-column prop="desc" label="备注"> </el-table-column>
        </el-table>
        <div class="btns">
          <el-button type="primary" @click="handleBtn">查看详情</el-button>
          <button class="second-btn" @click="handleBtn">驳回</button>
          <el-button type="primary" @click="handleBtn">业务受理</el-button>
        </div>
      </el-card>
    </div>
    <!-- 合同上传的对话框 -->
    <el-dialog
      class="uploadDialog"
      title="合同上传"
      :visible.sync="dialogVisible"
      width="50%">
      <el-form
        :model="form"
        :rules="rules"
        ref="uploadFormRef"
        label-position="left"
        label-width="100px">
        <el-form-item label="合同类型：" prop="type">
          <el-select v-model="form.contractType" placeholder="请选择合同类型">
            <el-option label="用电合同" :value="0">用电合同</el-option>
            <el-option label="扩容合同" :value="1">扩容合同</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同编号：" prop="id">
          <el-input
            v-model="form.contractNum"
            autocomplete="off"
            placeholder="请输入合同编号"></el-input>
        </el-form-item>
        <el-form-item label="签订日期：" prop="signingDate">
          <el-date-picker
            v-model="form.signTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="生效日期：" prop="effectiveDate">
          <el-date-picker
            v-model="form.takeTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="终止日期：" prop="terminationDate">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-upload
        name="myUpload"
        class="upload-demo"
        drag
        action="uploadAction"
        ref="uploadRef"
        :headers="headers"
        accept=".jpg,.jpeg,.png,.pdf"
        multiple
        :auto-upload="false"
        :on-change="changeFile"
        :show-file-list="true"
        :file-list="uploadFileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          只能单独上传jpg/png/jpeg图片或PDF文件，且PDF文件只能上传一份
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          style="background-color: #068d6c"
          type="primary"
          @click="submit('uploadFormRef')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 合同查看的对话框 -->
    <el-dialog
      class="viewDialog"
      title="合同预览"
      :visible.sync="viewDialog"
      width="50%"
      @open="handelFildContract"
      @close="closeDialog">
      <div class="dialogBody" v-if="isPDF">
        <div style="font-size: 18px; margin-bottom: 20px">
          区块链编号：
          <span style="font-size: 14px">{{ txID }}</span>
        </div>
        <iframe style="width: 100%; height: 800px" :src="pdfUrl"></iframe>
        <!-- <pdf ref="pdf" class="pdfClass" :src="pdfUrl" :page="pageNum" :rotate="pageRotate"
            @progress="loadedRatio = $event" @page-loaded="pageLoaded($event)" @num-pages="pageTotalNum = $event"
            @error="pdfError($event)" @link-clicked="page = $event">
          </pdf> -->
      </div>
      <div v-else class="dialogBody">
        <div class="txIdClass">
          <span>区块链编号：</span>
          <span>{{ txID }}</span>
        </div>
        <el-carousel indicator-position="outside" :interval="0">
          <el-carousel-item v-for="item in imageList" :key="item">
            <el-image
              id="img"
              :src="item"
              :preview-src-list="srcList"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FirstHeading from "@/components/firstHeading.vue";
// import { handleAddWaterMarker } from "@/utils/watermark.js";
// 导入api
import {
  getDataAcquisition,
  getDataAcquisitionNew,
  postUpData,
  getElectPrice,
  postElectPrice,
  postUploadFile,
  getHistoryFile,
  checkContract,
} from "@/api/energyManagement.js";
// import {
//   getFildContract
// } from "@/api/powerInformation.js";
import { getNow } from "@/utils/utils.js";

export default {
  name: "",
  components: { FirstHeading },
  async mounted() {
    // const res1 = await getDataAcquisition();
    // console.log(res1);

    this.userNum = sessionStorage.getItem("userNum");
    const res = await await getDataAcquisitionNew({ date: getNow() });
    // 数据采集 终端用户
    this.tableData1 = res.data.filter((item, i) => {
      return item.userNum != this.userNum;
    });
    // 数据采集 转供电主体
    this.tableData2 = res.data.filter((item, i) => {
      return item.userNum === this.userNum;
    });
    // 合同上传
    this.tableData3 = res.data.filter((item, i) => {
      // return item.fileUp === 0 && item.userNum != this.userNum;
      return item.userNum != this.userNum;
    });
  },
  data() {
    return {
      feng: "",
      ping: "",
      gu: "",
      upDate: "",
      num: 1,
      userNum: "",
      upuserNum: "",
      viewId: 0,
      uploadFiles: "",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      uploadFileList: [],
      fd: new FormData(), //上传的文件信息
      activeName: "upload",
      dialogVisible: false,
      form: {},
      rules: {
        fileType: [
          { required: true, message: "请选择合同类型", trigger: "change" },
        ],
        fileNum: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        signTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        takeTime: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
      viewDialog: false,
      isPDF: false, //文件类型（图片还是pdf），用于判断dialog中的内容显示
      pdfUrl: "",
      txID: "",
      srcList: [],
      imageList: [],
      dataList: [
        {
          workNum: "456123789",
          list: [
            {
              userNum: "451246",
              userName: "终端用户1号",
              phone: "13562359465",
              identity: "360281202345632135",
              address: "max科技园",
              type: "换设备",
              isBuilding: 0,
              desc: "",
            },
          ],
        },
        {
          workNum: "456123789",
          list: [
            {
              userNum: "451246",
              userName: "终端用户1号",
              phone: "13562359465",
              identity: "360281202345632135",
              address: "max科技园",
              type: "换设备",
              isBuilding: 0,
              desc: "",
            },
          ],
        },
        {
          workNum: "456123789",
          list: [
            {
              userNum: "451246",
              userName: "终端用户1号",
              phone: "13562359465",
              identity: "360281202345632135",
              address: "max科技园",
              type: "换设备",
              isBuilding: 0,
              desc: "",
            },
          ],
        },
      ],
      // searchForm:{},  //搜索表单
    };
  },
  methods: {
    handelChangePrice(price) {
      if (Number(price).toString() == "NaN" || Number(price) === "") {
        console.log("isNaN");
        this.$message.warning("请输入数字！");
      } else if (Number(price) < 0) {
        this.$message.warning("请输入大于0的数字！");
      }
    },
    async handleSubmitPrice() {
      if (
        Number(this.feng).toString() == "NaN" ||
        Number(this.ping).toString() == "NaN" ||
        Number(this.gu).toString() == "NaN" ||
        this.feng === "" ||
        this.ping === "" ||
        this.gu === ""
      ) {
        this.$message.warning("请输入数字！");
      } else if (
        Number(this.feng) < 0 ||
        Number(this.ping) < 0 ||
        Number(this.gu) < 0
      ) {
        this.$message.warning("请输入大于0的数字！");
      } else {
        const date = new Date();
        let strMonth;
        if (date.getMonth().toString().length === 1) {
          strMonth = "0" + (date.getMonth() + 1);
        } else {
          strMonth = date.getMonth() + 1;
        }
        const upDate = date.getFullYear() + "-" + strMonth;

        if (this.upDate === upDate) {
          this.$message.warning("本月已经修改过电价！");
        } else {
          const res = await postElectPrice({
            userNum: this.userNum,
            feng: this.feng,
            ping: this.ping,
            gu: this.gu,
          });
          this.$message.success(res.msg);
        }
      }
    },
    async handleSubmit(row) {
      row.electricInputE = false;
      row.electricInputEP = false;
      this.$forceUpdate();

      if (
        Number(row.electricNum).toString() == "NaN" ||
        Number(row.electricp).toString() == "NaN" ||
        row.electricNum === "" ||
        row.electricp === ""
      ) {
        this.$message.warning("请输入数字！");
      } else if (Number(row.electricNum) < 0 || Number(row.electricp) < 0) {
        this.$message.warning("请输入大于0的数字！");
      } else {
        const data = {
          userNum: row.userNum,
          electricNum: row.electricNum,
          electricp: row.electricp,
        };
        const res = await postUpData(data);
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    // 点击输入电量
    handelInputElectE(row) {
      row.electricInputE = true;
      this.$forceUpdate();
    },
    // 点击输入功率
    handelInputElectEP(row) {
      row.electricInputEP = true;
      this.$forceUpdate();
    },
    // 改变模块 获取电价
    async handelChangeMok(num) {
      // console.log(num);
      this.num = num;

      if (num === 2) {
        const res = await getElectPrice();
        // 电价
        if (res.code === 200) {
          this.feng = res.data.feng;
          this.ping = res.data.ping;
          this.gu = res.data.gu;
          this.upDate = res.data.upDate;
        } else {
          this.$message.warning(res.msg);
        }
      }
    },
    // 点击上传按钮
    handelUserNum(userNum) {
      this.upuserNum = userNum;
      this.dialogVisible = true;
    },
    // async handleUpload(file) {
    //   // const content = dayjs().format("YYYY-MM-DD HH:mm:ss"); // 当前时间
    //   // const name = this.uploadFiles.name.split(".")[0];
    //   // let fd = new FormData();
    //   // const reader = new FileReader();
    //   // reader.readAsDataURL(this.uploadFiles);
    //   // reader.onload = function () {
    //   //   const img = document.createElement("img"); // 手动创建一个img标签
    //   //   img.src = reader.result;
    //   //   img.onload = function () {
    //   //     const res = handleAddWaterMarker(img, content, name);
    //   //     fd.append("file", res);
    //   //     fd.append("userNum", this.upuserNum);
    //   //   };
    //   // };

    //   // console.log(fd);
    //   // console.log(11111111);
    //   console.log(file);
    //   console.log(this.uploadFileList);
    //   console.log(this.fd);
    //   // console.log(this.fileList);
    //   // console.log(this.fileList.length);

    //   // this.fd.append('file', file.file)
    //   // // console.log(this.fd.getAll('file').length ,this.fileTotalNum);
    //   // // 当fd的数组长度等于原始选中的文件长度，就证明已经添加完了，可以进行上传了
    //   // if (this.fd.getAll('file').length === this.fileTotalNum) {
    //   //   this.fd.append("userNum", this.upuserNum);
    //   //   try {
    //   //     const res = await postUploadFile(this.fd);
    //   //     //这里是上传成功之后要做的事情
    //   //     if (res.code === 200) {
    //   //       this.$message.success(res.msg);
    //   //     }
    //   //   } catch (error) {
    //   //     this.$message.error(error);
    //   //   } finally {
    //   //     //无论成功与失败都要清空文件列表，否则会出现无法上传的情况
    //   //     this.fileList = []
    //   //     this.fd.delete('file');
    //   //     this.fd.delete('userNum');
    //   //   }
    //   // }
    // },

    // 上传函数
    async handleUpload() {
      this.uploadFileList.forEach((item) => {
        console.log(item);
        this.fd.append("file", item);
      });
      for (const key in this.form) {
        if (Object.hasOwnProperty.call(this.form, key)) {
          // const element = object[key];
          this.fd.append(`${key}`, this.form[key]);
        }
      }
      this.fd.append("userNum", Number(this.upuserNum));
      try {
        const res = await postUploadFile(this.fd);
        //这里是上传成功之后要做的事情
        if (res.code === 200) {
          this.$message.success(res.msg);
        }
      } catch (error) {
        this.$message.error(error);
      } finally {
        this.form = {};
        this.$refs["uploadFormRef"].resetFields();
        this.uploadFileList = [];
        this.fd = new FormData();
      }
    },
    // 打开弹框选中一个文件就会触发这个函数
    changeFile(file, fileList) {
      console.log(file, fileList, this.uploadFileList);
      let fileRaw = file.raw;
      if (fileList.some((item) => item.lastModified == fileRaw.lastModified)) {
        // fileList.pop()
        return this.$message.error(`${fileRaw.name}已经在上传列表中了`);
      } else if (fileList.length > 1 && fileRaw.type.includes("pdf")) {
        // fileList.pop()
        return this.$message.error("图片和pdf不能同时上传！");
      } else {
        //获取添加文件进来的状态
        this.uploadFileList.push(file.raw);
        // //获取原始文件的个数(获取文件类型的input框DOM。往el-upload组件上加name属性会直接添加到input输入框上)
        // this.fileTotalNum = document.getElementsByName("myUpload")[0].files.length;
        // //如果原始文件和upload的个数相同的时候就说明已经添加完了，可以触发上传的方法了
        // if (this.uploadFileList.length === this.fileTotalNum) {
        //   // 当选取的文件个数大于1且其中包含pdf文件时，不进行上传
        //   if (this.uploadFileList.length > 1 && !this.uploadFileList.every((item) => { return item.type.includes('image') })) {
        //     // 不符合上传要求，将要上传的文件列表重新置空
        //     this.uploadFileList = []
        //     return this.$message.error('只能上传一份pdf文件或上传一张或多张图片')
        //   }
        //   //获取上传文件的组件
        //   const Uploader = this.$refs[`uploadRef`];
        //   //触发上传文件列表的方法
        //   Uploader.submit();
        // }
      }
    },
    // 对话框提交函数
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.uploadFileList.length >= 1) {
          //获取上传文件的组件
          // this.$refs.uploadRef.submit();
          this.handleUpload();
        } else {
          console.log("error submit!!");
          return this.$message.error("请填写完整信息！");
        }
      });
    },
    // 打开查看合同对话框的回调函数
    async handelFildContract() {
      const res = await checkContract(this.viewId);
      if (res.code === 200) {
        if (res.data.length === 0) {
          this.$message.warning("合同未上传！");
        } else {
          console.log(res.data);
          this.isPDF = res.data.fileType === 0;
          // 合同为pdf格式
          if (this.isPDF) {
            // window.open(res.data[0].url)
            this.pdfUrl = `${res.data.urlList[0]}?${res.data.hash}`;
            // this.txID = res.data.hash;
          } else {
            // 合同为image图片
            this.imageList = res.data.urlList;
            this.srcList = res.data.urlList;
            // this.txID = res.data.hash;
            // this.imageList = res.data;
            // res.data.forEach((item, i) => {
            //   this.srcList.push(item.url);
            // });
          }
        }
      }
    },
    // 关闭查看合同对话框的回调函数
    closeDialog() {
      this.srcList = [];
      this.imageList = [];
    },
    // 点击查看按钮
    changeViewUserNum(row) {
      this.txID = row.qklHash;
      this.viewId = row.id;
      this.viewDialog = true;
    },
    // // 历史合同查询按钮
    // handleSearch() {
    //   if (JSON.stringify(this.searchForm) === '{}') return
    //   this.getHistoryData()
    // },
    // 获取历史合同数据
    async getHistoryData() {
      // const query = JSON.stringify(this.searchForm) === '{}' ? '':this.searchForm
      // const res = await getHistoryFile(this.searchForm)
      const res = await getHistoryFile();
      if (res.code === 200) {
        this.tableData4 = res.data;
      } else return this.$message.error(res.msg);
    },
    // 改变合同管理页面的tab页的函数
    changeTabs() {
      if (this.activeName === "history") {
        this.getHistoryData();
      }
    },
    /**业务审核部分 */
    handleBtn() {
      this.$message.warning("暂无权限");
    },
  },
};
</script>

<style lang="scss" scoped>
.energyManageZhuan {
  max-width: 1872px;
  margin: 0 auto;
  padding-top: 20px;
  box-sizing: border-box;

  .topCard {
    height: 64px;
    font-size: 18px;
    font-weight: 600;

    span {
      color: #068667 !important;
    }

    .btns {
      float: right;
      position: relative;
      top: -6px;

      > span {
        color: #d3d9d7;
        font-size: 12px;
      }

      .el-button {
        margin: 0 10px;
        background: #fff;
        color: #8b9996;
      }

      .active {
        background: #068d6c;
        color: #fff;
      }
    }
  }

  .bottomCard {
    height: 878px;
    margin-top: 20px;
    position: relative;
    width: 100%;
    box-sizing: border-box;

    ::v-deep .el-card__body {
      box-sizing: border-box;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .bottomCard1,
      .bottomCard2 {
        width: 100%;
        position: absolute;
        top: 20px;

        .infoBox {
          position: relative;
          height: 112px;
          margin-right: 40px;
          background-color: #f5f7f7;
          border: 1px solid #cfd9d7;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          > div {
            margin: 0 80px;
            font-size: 14px;
            color: #000;
          }
        }
      }

      .bottomCard2 {
        .infoBox {
          padding: 30px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: space-around;

          div {
            height: 100%;
            display: flex;
            align-items: center;
            font-size: 14px;

            .span {
              display: block;
              width: 100px !important;
            }

            .el-input {
              flex: 1;
              height: 32px;
            }

            .yuan {
              font-style: normal;
              font-weight: bold;
              line-height: 32px;
            }
          }

          .line {
            height: 100%;
            border-right: 1px solid #8b9996;
          }

          .el-button {
            margin-right: 20px;

            &:hover {
              background: #068d6c;
              border-color: #068d6c;
              color: #fff;
            }

            &:focus {
              background: #068d6c;
              border-color: #068d6c;
              color: #fff;
            }
          }
        }
      }

      .bottomCard3,
      .bottomCard4 {
        width: 100%;
        position: absolute;
        top: 20px;
        box-sizing: border-box;
        padding-right: 40px;
      }

      .bottomCard3 {
        .el-table__body-wrapper {
          &::-webkit-scrollbar {
            // 整个滚动条
            width: 0; // 纵向滚动条的宽度
            background: rgba(213, 215, 220, 0.3);
            border: none;
          }

          &::-webkit-scrollbar-track {
            // 滚动条轨道
            border: none;
          }

          .el-table th.gutter {
            display: none;
            width: 0;
          }

          .el-table colgroup col[name="gutter"] {
            display: none;
            width: 0;
          }

          .el-table__body {
            width: 100% !important;
          }

          ::v-deep .el-table__cell {
            width: 0 !important;
          }
        }

        .el-button {
          width: 80px;
          height: 32px;
          background: #d2eee7;
          color: #068d6c;
          padding: 0;
        }
      }

      .bottomCard4 {
        .el-table__body-wrapper {
          &::-webkit-scrollbar {
            // 整个滚动条
            width: 0; // 纵向滚动条的宽度
            background: rgba(213, 215, 220, 0.3);
            border: none;
          }

          &::-webkit-scrollbar-track {
            // 滚动条轨道
            border: none;
          }

          .el-table th.gutter {
            display: none;
            width: 0;
          }

          .el-table colgroup col[name="gutter"] {
            display: none;
            width: 0;
          }

          .el-table__body {
            width: 100% !important;
          }

          ::v-deep .el-table__cell {
            width: 0 !important;
          }
        }

        .uploadBtn {
          padding: 0;
          color: #068d6c;
          font-weight: 700;
        }

        .demo-form-inline {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .searchBtn {
            background-color: #068d6c;
            color: #fff;
          }
        }
      }
    }
  }

  .bottom {
    .box {
      margin-top: 20px;
      margin-bottom: 20px;

      ::v-deep .el-card__body {
        padding: 40px;
        box-sizing: border-box;

        .btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
          button {
            width: 120px;
          }
          .second-btn {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            background: #8d0f06;
            border: 0;
            color: #fff;
            -webkit-appearance: none;
            text-align: center;
            box-sizing: border-box;
            outline: 0;
            margin: 0;
            transition: 0.1s;
            font-weight: 500;
            padding: 12px 20px;
            font-size: 14px;
            border-radius: 4px;
            margin: 0 10px;
            &:hover {
              background: #694d4a;
              // color: #8d0f06;
            }
          }
        }
      }
    }
  }

  .uploadDialog {
    ::v-deep .el-dialog__body {
      display: flex;

      .el-form {
        flex: 1;
      }

      .upload-demo {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }

  .viewDialog {
    :deep(.dialogBody) {
      width: 100% !important;

      .el-carousel__container {
        height: 600px;

        .el-carousel__item {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .el-image {
          width: 100%;
          height: 90%;

          > img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .txIdClass {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;

          > span:nth-child(1) {
            // font-size: 18px;
          }
        }
      }

      .txIdClass {
        margin-bottom: 10px;

        > span:nth-child(1) {
          font-size: 18px;
        }

        > span:nth-child(2) {
          font-size: 18px;
          color: #068667;
        }
      }
    }
  }
}
</style>
